<script setup lang="ts">
  import { marked } from 'marked'
  import { cva } from 'class-variance-authority'

  const props = withDefaults(
    defineProps<{
      blok: any
      compact?: boolean
    }>(),
    {
      compact: false
    }
  )

  const cardBase = computed(() =>
    cva('flex overflow-hidden flex-col rounded-sm', {
      variants: {
        compact: {
          true: 'shadow-xs grow md:w-full',
          false: 'md:flex-row md:col-span-3 [&_img]:md:rounded-l-sm md:rounded-t-none shadow-xs'
        }
      }
    })({
      compact: props.compact
    })
  )

  const output = computed(() => marked(props.blok.content))
  const hasImage = computed(() => !!props.blok?.image?.filename)

  const { isDesktop } = useBTBreakpoints()

  const imageWidth = computed(() => {
    if (isDesktop.value) {
      return 450
    }

    return 728
  })

  const imageHeight = computed(() => {
    if (isDesktop.value) {
      return 340
    }

    return 200
  })
</script>

<template>
  <div
    v-editable="blok"
    :class="cardBase"
  >
    <!--  16 / 9 -->
    <NuxtImg
      v-if="hasImage"
      provider="storyblok"
      :src="blok.image.filename"
      :alt="blok.image.alt"
      class="h-50 w-full object-cover md:h-85 md:w-auto"
      loading="lazy"
      :height="imageHeight"
      :width="imageWidth"
      :modifiers="{ filters: { focal: blok?.image?.focus }, smart: true }"
    />
    <div class="grow rounded-br-sm px-4 pb-10 pt-6">
      <div
        class="[&_a]:text-inherit"
        v-html="output"
      />
    </div>
  </div>
</template>
